import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<
	| 'unpinConfirmModalTitle'
	| 'unpinConfirmModalBody'
	| 'unpinConfirmModalCancelLabel'
	| 'unpinConfirmModalConfirmLabel',
	MessageDescriptor
> = defineMessages({
	unpinConfirmModalTitle: {
		id: 'rovo-pins.unpin-confirm-modal.title',
		defaultMessage: 'Unpin this item?',
		description: 'Title of the confirmation modal shown when a user clicks Unpin on a pinned item',
	},
	unpinConfirmModalBody: {
		id: 'rovo-pins.unpin-confirm-modal.body',
		defaultMessage: 'You can pin it again anytime.',
		description:
			'Body text of the unpin confirmation modal, reassuring the user the action is reversible',
	},
	unpinConfirmModalCancelLabel: {
		id: 'rovo-pins.unpin-confirm-modal.cancel-label',
		defaultMessage: 'Cancel',
		description:
			'Label for the button that dismisses the unpin confirmation modal without unpinning',
	},
	unpinConfirmModalConfirmLabel: {
		id: 'rovo-pins.unpin-confirm-modal.confirm-label',
		defaultMessage: 'Confirm',
		description: 'Label for the button that confirms unpinning the item',
	},
});

export default messages;
